import Header from "../../Header/Header";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { privateRequest } from "../../commonApi/CommonApi";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
const daysOptions = [
  { value: "Monday", label: "Monday" },
  { value: "Tuesday", label: "Tuesday" },
  { value: "Wednesday", label: "Wednesday" },
  { value: "Thursday", label: "Thursday" },
  { value: "Friday", label: "Friday" },
  { value: "Saturday", label: "Saturday" },
  { value: "Sunday", label: "Sunday" },
];
function Editcoupons() {
  const { state } = useLocation();

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedExOptions, setSelectedExOptions] = useState([]);
  const [serviceExOptions, setServiceExOptions] = useState([]);
  const [couponCode, setCouponCode] = useState(state?.couponCode);
  const [selectedParentCategory, setSelectedParentCategory] = useState();
  const [selectedChildCategories, setSelectedChildCategories] = useState();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [couponTitle, setCouponTitle] = useState(state?.couponTitle);
  const [couponSubTitle, setCouponSubTitle] = useState(state?.couponSubTitle);
  const [couponType, setCouponType] = useState(state?.couponType);
  const [couponValue, setCouponValue] = useState(state?.couponValue);
  const [minSpend, setMinSpend] = useState(state?.minSpend);
  const [expiryDate, setExpiryDate] = useState(new Date());
  const [couponUsesLimit, setCouponUsesLimit] = useState(
    state?.couponUsesLimit
  );
  const [userUsesLimit, setUserUsesLimit] = useState(state?.userUsesLimit);
  const [couponCapping, setCouponCapping] = useState(state?.couponCapping);
  const [Status, setStatus] = useState(state?.Status == true ? 1 : 0);
  const [combineData, setCombineData] = useState([]);
  const [childCategoryOptions, setChildCategoryOptions] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [SelectedChildCategory, setSelectedChildCategory] = useState("");
  const [Users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState();
  const [selectedFreeService, setSelectedFreeService] = useState(
    state?.serviceId
  );

  const [couponDescription, setcouponDescription] = useState([]);
  const [selectedexUsers, setSelectedexUsers] = useState([]);
  const [ServiceGroupOptions, setServiceGroupOptions] = useState([]);
  const [selectAllInItem, setselectAllInItem] = useState(false);
  const [selectAllExItem, setselectAllExItem] = useState(false);

  const [selectedDays, setSelectedDays] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [debouncedInput, setDebouncedInput] = useState("");

  const handleShow = () => {
    setName("");
    setEmail("");
    setMobile("");
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const navigate = useNavigate();

  const handleInputChange = (index, event) => {
    const values = [...couponDescription];
    values[index] = event.target.value;
    setcouponDescription(values);
  };

  const handleAddInput = () => {
    setcouponDescription([...couponDescription, ""]);
  };

  const handleDeleteInput = (index) => {
    const values = [...couponDescription];
    values.splice(index, 1);
    setcouponDescription(values);
  };

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get("Service/CombineApis");
      setCombineData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const getUsers = async () => {
    try {
      const response = await privateRequest.get("Appregister/getAllUser");
      setUsers(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const handleServiceChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
  };

  const freeServiceOptions =
  combineData?.newServiceId
    ?.filter(
      (service) =>
        service?.PCatId?.PCGroup === selectedParentCategory?.value
    )
    ?.flatMap((service) =>
      service?.ServiceVarients?.map((variant) => ({
        value: variant?._id,
        label: `${service?.ServiceName} (${variant?.ServiceType?.Name})`,
      }))
    ) || [];

    const filteredOptions = debouncedInput
  ? freeServiceOptions.filter((option) =>
      option.label
        ?.toLowerCase()
        .includes(debouncedInput.toLowerCase())
    )
  : freeServiceOptions;

  let services = serviceOptions[0]?.options ?? [];
  let packages = serviceOptions[1]?.options ?? [];

  let both = [...services, ...packages];

  useEffect(() => {
    if (selectAllInItem == true) {
      setSelectedOptions(both);
    } else {
      setSelectedOptions([]);
    }
  }, [selectAllInItem]);

  useEffect(() => {
    if (selectAllExItem == true) {
      setSelectedExOptions(both);
    } else {
      setSelectedExOptions([]);
    }
  }, [selectAllExItem]);

  useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedInput(searchInput);
  }, 400);

  return () => clearTimeout(timer);
}, [searchInput]);

  const handleServiceEXChange = (selectedOptions) => {
    setSelectedExOptions(selectedOptions);
  };

  const handleUserChange = (selectedOptions) => {
    setSelectedUsers(selectedOptions);
  };

  const filteredUsers =
    Users.length > 0 &&
    Users?.filter((user) => state?.exUserIDs?.includes(user?._id));
  const filteredInUsers =
    Users.length > 0 &&
    Users?.filter((user) => state?.inUserIDs?.includes(user?._id));

  let ExUsers =
    filteredUsers.length > 0 &&
    filteredUsers?.map((user) => ({
      value: user?._id,
      label: user?.mobileNo + " (" + user?.name + ")",
    }));
  let InUsers =
    filteredInUsers.length > 0 &&
    filteredInUsers?.map((user) => ({
      value: user?._id,
      label: user?.mobileNo + " (" + user?.name + ")",
    }));

  let filteredInItems = both?.filter((item) =>
    state?.inItem.includes(item.value)
  );
  let filteredExItems = both?.filter((item) =>
    state?.exItem.includes(item.value)
  );

  useEffect(() => {
    if (Users) {
      setSelectedUsers(InUsers);
      setSelectedexUsers(ExUsers);
    }
  }, [Users]);
  useEffect(() => {
    if (serviceOptions) {
      setSelectedExOptions(filteredExItems);
      setSelectedOptions(filteredInItems);
    }
  }, [serviceOptions]);

  const handleexUserChange = (selectedOptions) => {
    setSelectedexUsers(selectedOptions);
  };

  const AddCoupons = async (event) => {
    event.preventDefault();

    try {
      const selectedOptionIdsString = selectedOptions?.map(
        (option) => option.value
      );
      const selectedOptionIds = selectedExOptions?.map(
        (option) => option.value
      );
      const selectedUserIds = selectedUsers
        ? selectedUsers?.map((user) => user.value)
        : [];
      const selectedexUserIds = selectedexUsers
        ? selectedexUsers?.map((user) => user.value)
        : [];
      const selectedDaysValues = selectedDays.map((day) => day.value);
      const formData = {
        couponCode,
        PCgroup: selectedParentCategory?.value,
        PCatId: selectedChildCategories?.map((item) => item?.value),
        inItem: selectedOptionIdsString,
        exItem: selectedOptionIds,
        inUserIDs: selectedUserIds || [],
        exUserIDs: selectedexUserIds || [],
        couponDays: selectedDaysValues || [],
        couponTitle,
        couponSubTitle,
        couponType,

        minSpend,
        couponDescription,
        expiryDate,
        couponUsesLimit,
        userUsesLimit,
        couponCapping,
        Status,
        ...(selectedFreeService && { serviceId: selectedFreeService }),
        ...(couponType !== "FreeService" && { couponValue: couponValue }),
      };
      const response = await privateRequest.put(
        `/coupons/UpdateCoupon/${state._id}`,
        formData
      );
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Coupons Update successfully!",
      });
      navigate("/coupons");
      console.log("POST Response:", response);

      setCouponCode("");
      setSelectedGroup(null);
      setCouponTitle("");
      setCouponSubTitle("");
      setCouponType("");
      setCouponValue("");
      setMinSpend("");
      setExpiryDate("");
      setCouponUsesLimit("");
      setUserUsesLimit("");
      setCouponCapping("");
      setStatus("");
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to add Coupons.",
      });
    }
  };

  const duplicateInput = () => {
    const table = document.getElementById("tctable");
    const row = table.insertRow(-1); // Insert row at the end of the table
    const cell1 = row.insertCell(0);
    const cell2 = row.insertCell(1);

    // Create a new input field
    const input = document.createElement("input");
    input.type = "text";
    input.className = "form-control";
    input.placeholder = "Coupon Description";
    input.name = "cpn_discription";
    input.value = couponDescription;
    input.addEventListener("input", (e) =>
      setcouponDescription(e.target.value)
    );

    cell1.appendChild(input);

    // Create a new delete button
    const deleteButton = document.createElement("button");
    deleteButton.type = "button";
    deleteButton.className = "btn btn-primary btn-icon btnDelete";
    deleteButton.textContent = "x";
    deleteButton.addEventListener("click", () => {
      table.deleteRow(row.rowIndex);
    });

    cell2.appendChild(deleteButton);
  };

  function generateCoupon() {
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var code = "";
    for (var i = 0; i < 12; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    setCouponCode(code);
  }

  const handleParentCategoryChange = (selectedOption) => {
    setSelectedParentCategory({
      id: selectedOption?.value,
      label: selectedOption?.label,
    });
    setSelectedChildCategory("");
  };

  useEffect(() => {
    if (state) {
      let a =
        state?.PCatId.map((category) => ({
          value: category._id,
          label: category.PCName,
        })) || [];

      setSelectedChildCategories(a);

      let b = {
        value: state?.PCgroup._id,
        label: state?.PCgroup.PCGName,
      };
      setSelectedParentCategory(b);
      setExpiryDate(state?.expiryDate.slice(0, 10));

      let precouponDays = state?.couponDays.map((item) => ({
        value: item,
        label: item,
      }));

      if (state.couponDays.length > 0) {
        setSelectedDays(precouponDays);
      }
    }
  }, [state]);

  useEffect(() => {
    getAllDocumentData();
    getUsers();
  }, []);

  useEffect(() => {
    const childCategorySelectOptions = combineData?.parentCategories
      ?.filter((category) => category.PCGroup === selectedParentCategory?.value)
      ?.map((category) => ({
        value: category._id,
        label: category.PCName,
      }));

    setChildCategoryOptions(childCategorySelectOptions || []);
  }, [selectedParentCategory, combineData?.parentCategories, state]);

  useEffect(() => {
    const serviceGroupSelectOptions = combineData?.serviceGroups
      ?.filter((group) => group.PCName[0] === selectedParentCategory)
      ?.map((group) => ({
        value: group._id,
        label: group.GroupName,
      }));
    setServiceGroupOptions(serviceGroupSelectOptions || []);
  }, [selectedParentCategory, combineData?.serviceGroups]);

  useEffect(() => {
    if (
      selectedChildCategories?.length > 0 &&
      combineData?.newServiceId &&
      combineData?.Package
    ) {
      const selectedServices = combineData?.newServiceId
        .filter((service) => {
          if (Array.isArray(service.PCatId)) {
            return selectedChildCategories?.some((category) =>
              service?.PCatId?.includes(category.value)
            );
          }
          return true;
        })
        .flatMap((service) =>
          service.ServiceVarients.map((varient) => {
            const serviceTypeId = varient?.ServiceType ? varient?._id : null;
            const serviceTypeName =
              varient?.ServiceType?.Name != "NA"
                ? varient?.ServiceType?.Name
                : service?.ChildCatIDs?.CCName;
            return {
              value: serviceTypeId,
              label: `${service.ServiceName} (${serviceTypeName})`,
              type: "Service",
            };
          })
        );

      const selectedPackages = combineData?.Package?.filter((packag) =>
        selectedChildCategories?.some((category) =>
          packag.PcatId.includes(category.value)
        )
      ).map((packag) => ({
        value: packag._id,
        label: packag.packageTitle,
        type: "Package",
      }));
      const combinedOptions = [
        { label: "Services", options: selectedServices },
        { label: "Packages", options: selectedPackages },
      ];
      setServiceOptions(combinedOptions);
      setServiceExOptions(combinedOptions);
    } else {
      setServiceOptions([]);
    }
  }, [selectedChildCategories, combineData]);

  const handleChildCategoryChange = (selectedOptions) => {
    const selectedIds = selectedOptions?.map((option) => ({
      value: option.value,
      label: option.label,
    }));
    setSelectedChildCategories(selectedIds);
  };

  const handleDaysChange = (selectedOptions) => {
    setSelectedDays(selectedOptions);
  };
  // let finalInItemOptions = [];
  // if (selectedOptions && Array.isArray(selectedOptions)) {
  //   let a = [...selectedExOptions, ...selectedOptions];
  //   finalInItemOptions = both.filter((item) => !a.includes(item));
  // } else {
  //   // Handle the case where selectedUsers is not iterable (null, undefined, or not an array)
  //   console.error(
  //     "selectedoptions is not iterable or is not defined properly."
  //   );
  // }

  let a = [...selectedExOptions, ...selectedOptions];
  let finalInItemOptions = both.filter((item) => !a.includes(item));

  let normalUserOptions = [];
  if (
    selectedUsers &&
    Array.isArray(selectedUsers) &&
    selectedexUsers &&
    Array.isArray(selectedexUsers)
  ) {
    normalUserOptions = [...selectedUsers, ...selectedexUsers];
  } else {
    // Handle the case where selectedUsers is not iterable (null, undefined, or not an array)
    console.error("selectedUsers is not iterable or is not defined properly.");
  }

  let normalUserOptionsIds = normalUserOptions.map((user) => user.value); // or user._id, adjust as per your data structure

  let finalInUserOptions = Users.filter((item) => {
    return !normalUserOptionsIds.includes(item._id);
  });
  useEffect(() => {
    if (state?.couponDescription) {
      setcouponDescription(state?.couponDescription);
    }
  }, [state]);

  const AddUsers = async (event) => {
    event.preventDefault();
    let body = {
      name: name,
      email: email,
      mobileNo: mobile,
    };
    try {
      let response = await privateRequest.post(`Appregister/AddNewUser`, body);
      if (response) {
        getUsers();
      }

      console.log("POST/PUT Response:", response);

      setShowModal(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "User added successfully!",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.message,
      });
      console.error("Add Error:", error);
    }
  };

  return (
    <>
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Edit Coupons</span>
                    </p>
                    <Link
                      to="/coupons"
                      className="btn btn-primary btn-sm ml-auto"
                    >
                      All Coupons
                    </Link>
                  </div>
                </header>
                <div className="page-section">
                  <form
                    id="new_coupon"
                    className="needs-validation"
                    noValidate=""
                    onSubmit={AddCoupons}
                  >
                    <div className="row">
                      <div className="col-lg-9">
                        <div className="card card-body">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="input-group input-group-alt mb-3">
                                <input
                                  type="text"
                                  id="cpn_code"
                                  className="form-control"
                                  placeholder="Coupon Code"
                                  name="cpn_code"
                                  value={couponCode}
                                  required
                                  onChange={(e) =>
                                    setCouponCode(e.target.value)
                                  }
                                />
                                <div className="input-group-append">
                                  <button
                                    type="button"
                                    className="btn btn-primary rounded-0 generate_cpn"
                                    onClick={generateCoupon}
                                  >
                                    Generate Coupon
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <Select
                                  isClearable
                                  label={selectedParentCategory}
                                  value={selectedParentCategory}
                                  onChange={(selectedOption) => {
                                    handleParentCategoryChange(selectedOption);
                                    console.log(
                                      "selectedOption",
                                      selectedOption
                                    );
                                  }}
                                  required
                                  options={
                                    combineData?.ParentGroup?.map(
                                      (category) => ({
                                        value: category._id,
                                        label: category.PCGName,
                                      })
                                    ) || []
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <Select
                                  isMulti
                                  required
                                  value={selectedChildCategories}
                                  onChange={handleChildCategoryChange}
                                  options={childCategoryOptions}
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <input
                                  type="text"
                                  id="cpn_title"
                                  className="form-control"
                                  placeholder="Coupon Title"
                                  name="cpn_title"
                                  value={couponTitle}
                                  required
                                  onChange={(e) =>
                                    setCouponTitle(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="form-group">
                                <input
                                  type="text"
                                  id="cpn_discription"
                                  className="form-control"
                                  placeholder="Coupon Discription"
                                  name="cpn_discription"
                                  value={couponSubTitle}
                                  onChange={(e) =>
                                    setCouponSubTitle(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                            <div className=" col-lg-12">
                              <div className="form-group">
                                <div className="d-flex justify-content-between align-items-center">
                                  <label htmlFor="coupon_days">
                                    Select Days
                                  </label>
                                  <div className="custom-control custom-control-inline custom-checkbox ml-5">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id="days"
                                      onChange={(e) => {
                                        if (e.target.checked == true) {
                                          setSelectedDays(daysOptions);
                                        } else {
                                          setSelectedDays([]);
                                        }
                                      }}
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="days"
                                    >
                                      Select All
                                    </label>
                                  </div>
                                </div>
                                <Select
                                  isMulti
                                  name="days"
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  placeholder="Select Days"
                                  options={daysOptions}
                                  value={selectedDays}
                                  onChange={handleDaysChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card">
                          <div className="card-header nav-scroller">
                            <ul className="nav nav-tabs card-header-tabs">
                              <li className="nav-item">
                                <a
                                  className="nav-link active show"
                                  data-toggle="tab"
                                  href="#general_C"
                                >
                                  General
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  data-toggle="tab"
                                  href="#Uses_resti"
                                >
                                  Explore Usage restriction
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  data-toggle="tab"
                                  href="#cpntnc"
                                >
                                  Coupon Terms &amp; Condition
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div className="card-body">
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="tab-content">
                                  <div
                                    className="tab-pane active"
                                    id="general_C"
                                  >
                                    <div className="row">
                                      <div className="form-group col-lg-6">
                                        <label htmlFor="coupon_type">
                                          Coupon Type
                                        </label>
                                        <select
                                          className="form-control"
                                          value={couponType}
                                          required
                                          onChange={(e) =>
                                            setCouponType(e.target.value)
                                          }
                                        >
                                          <option value="">Select Type</option>
                                          <option value="Fixed">Fixed</option>
                                          <option value="FreeService">
                                            Free Service
                                          </option>
                                          <option value="discount">
                                            Discount
                                          </option>
                                          <option value="FirstTime">
                                            First Time User
                                          </option>
                                        </select>
                                      </div>

                                      {couponType !== "FreeService" && (
                                        <div className="form-group col-lg-6">
                                          <label htmlFor="coupon_amount">
                                            Coupon Value
                                          </label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            name="coupon_amount"
                                            id="coupon_amount"
                                            value={couponValue}
                                            onChange={(e) =>
                                              setCouponValue(e.target.value)
                                            }
                                            defaultValue={0}
                                            placeholder={0}
                                          />
                                        </div>
                                      )}
                                      {couponType === "discount" && (
                                        <div className="form-group col-lg-6">
                                          <label htmlFor="coupon_capping">
                                            Coupon Capping
                                          </label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            style={{}}
                                            name="coupon_capping"
                                            id="coupon_capping"
                                            defaultValue={0}
                                            placeholder={0}
                                            value={couponCapping}
                                            onChange={(e) =>
                                              setCouponCapping(e.target.value)
                                            }
                                          />
                                        </div>
                                      )}
                                        {couponType === "FreeService" && (
                                          <div className="form-group col-lg-6">
                                            <label htmlFor="free_service">Free Service</label>

                                            <Select
                                              inputId="free_service"
                                              className="m-0"
                                              placeholder="Search & Select Service"
                                              options={filteredOptions}
                                              value={freeServiceOptions.find(
                                                (opt) => opt.value === selectedFreeService
                                              )}
                                              onChange={(option) =>
                                                setSelectedFreeService(option ? option.value : null)
                                              }
                                              onInputChange={(inputValue) => setSearchInput(inputValue)}
                                              isClearable
                                              isSearchable
                                              noOptionsMessage={() => "No service found"}
                                            />
                                          </div>
                                        )}
                                      <div className="form-group col-lg-6">
                                        <label htmlFor="minimum_amount">
                                          Minimum spend
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="minimum_amount"
                                          id="minimum_amount"
                                          defaultValue=""
                                          required
                                          placeholder="No minimum"
                                          value={minSpend}
                                          onChange={(e) =>
                                            setMinSpend(e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className="form-group col-lg-6">
                                        <label htmlFor="expiry_date">
                                          Coupon expiry date
                                        </label>
                                        <input
                                          type="date"
                                          className="form-control"
                                          name="expiry_date"
                                          id="expiry_date"
                                          placeholder="YYYY-MM-DD"
                                          value={expiryDate}
                                          required
                                          onChange={(e) =>
                                            setExpiryDate(e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className="form-group col-lg-6">
                                        <label htmlFor="usage_limit">
                                          Usage limit per coupon
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          name="usage_limit"
                                          id="usage_limit"
                                          defaultValue=""
                                          placeholder="Unlimited usage"
                                          step={1}
                                          required
                                          min={0}
                                          value={couponUsesLimit}
                                          onChange={(e) =>
                                            setCouponUsesLimit(e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className="form-group col-lg-6">
                                        <label htmlFor="usage_limit_per_user">
                                          Usage limit per user
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          name="usage_limit_per_user"
                                          id="usage_limit_per_user"
                                          defaultValue=""
                                          placeholder="Unlimited usage"
                                          step={1}
                                          min={0}
                                          required
                                          value={userUsesLimit}
                                          onChange={(e) =>
                                            setUserUsesLimit(e.target.value)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="tab-pane" id="Uses_resti">
                                    <div className="row">
                                      <div className="col-12">
                                        <div id="cpn_ser_area">
                                          <hr />
                                          <div className="form-group">
                                            <div className="d-flex">
                                              <label>Include Items</label>
                                              <div className="custom-control custom-control-inline custom-checkbox ml-auto">
                                                <input
                                                  type="checkbox"
                                                  value=""
                                                  className="custom-control-input"
                                                  id="inc_package_checkbox"
                                                  onChange={(e) => {
                                                    setselectAllInItem(
                                                      !selectAllInItem
                                                    );
                                                  }}
                                                />
                                                <label
                                                  className="custom-control-label"
                                                  htmlFor="inc_package_checkbox"
                                                >
                                                  Select All
                                                </label>
                                              </div>
                                            </div>
                                            <Select
                                              placeholder={
                                                "Select Included Service"
                                              }
                                              isMulti
                                              value={selectedOptions}
                                              onChange={handleServiceChange}
                                              options={finalInItemOptions?.filter(
                                                (option) =>
                                                  !selectedOptions?.some(
                                                    (selected) =>
                                                      selected.value ===
                                                      option.value
                                                  )
                                              )}
                                              getOptionLabel={(option) =>
                                                option.label
                                              }
                                              getOptionValue={(option) =>
                                                option.value
                                              }
                                              getOptionIsDisabled={(option) =>
                                                option.disabled
                                              }
                                              formatGroupLabel={(data) => (
                                                <h6>{data.label}</h6>
                                              )}
                                            />

                                            <span
                                              className="select2 select2-container select2-container--default"
                                              dir="ltr"
                                              data-select2-id={2}
                                              style={{ width: "100%" }}
                                            >
                                              <span
                                                className="dropdown-wrapper"
                                                aria-hidden="true"
                                              />
                                            </span>
                                          </div>
                                        </div>
                                        <div id="cpn_pac_area">
                                          <hr />
                                          <div className="form-group">
                                            <div className="d-flex">
                                              <label>Exclude Item</label>
                                              <div className="custom-control custom-control-inline custom-checkbox ml-auto">
                                                <input
                                                  type="checkbox"
                                                  className="custom-control-input"
                                                  id="exc_package_checkbox"
                                                  onChange={() => {
                                                    setselectAllExItem(
                                                      !selectAllExItem
                                                    );
                                                  }}
                                                />
                                                <label
                                                  className="custom-control-label"
                                                  htmlFor="exc_package_checkbox"
                                                >
                                                  Select All
                                                </label>
                                              </div>
                                            </div>
                                            <Select
                                              placeholder={
                                                "Select Excluded Service"
                                              }
                                              isMulti
                                              value={selectedExOptions}
                                              onChange={handleServiceEXChange}
                                              options={finalInItemOptions}
                                            />
                                            <span
                                              className="select2 select2-container select2-container--default"
                                              dir="ltr"
                                              data-select2-id={2}
                                              style={{ width: "100%" }}
                                            >
                                              <span
                                                className="dropdown-wrapper"
                                                aria-hidden="true"
                                              />
                                            </span>
                                          </div>
                                        </div>
                                        <div id="cpn_pac_area">
                                          <hr />
                                          <div className="form-group">
                                            <div className="d-flex">
                                              <label>Include Users</label>
                                            </div>
                                            <Select
                                              placeholder={
                                                "Select Included User"
                                              }
                                              isMulti
                                              value={selectedUsers}
                                              options={finalInUserOptions.map(
                                                (user) => ({
                                                  value: user._id,
                                                  label:
                                                    user?.mobileNo +
                                                    " (" +
                                                    user?.name +
                                                    ")",
                                                })
                                              )}
                                              onChange={handleUserChange}
                                            />
                                            <button
                                              type="button"
                                              className="btn btn-primary"
                                              onClick={handleShow}
                                              id="newUser"
                                            >
                                              Add New
                                            </button>
                                            <span
                                              className="select2 select2-container select2-container--default"
                                              dir="ltr"
                                              data-select2-id={2}
                                              style={{ width: "100%" }}
                                            >
                                              <span
                                                className="dropdown-wrapper"
                                                aria-hidden="true"
                                              />
                                            </span>
                                          </div>
                                        </div>
                                        <div id="cpn_pac_area">
                                          <hr />
                                          <div className="form-group">
                                            <div className="d-flex">
                                              <label>Exclude Users</label>
                                            </div>
                                            <Select
                                              placeholder={
                                                "Select Excluded User"
                                              }
                                              isMulti
                                              value={selectedexUsers}
                                              options={finalInUserOptions.map(
                                                (user) => ({
                                                  value: user._id,
                                                  label:
                                                    user?.mobileNo +
                                                    " (" +
                                                    user?.name +
                                                    ")",
                                                })
                                              )}
                                              onChange={handleexUserChange}
                                            />

                                            <span
                                              className="select2 select2-container select2-container--default"
                                              dir="ltr"
                                              data-select2-id={2}
                                              style={{ width: "100%" }}
                                            >
                                              <span
                                                className="dropdown-wrapper"
                                                aria-hidden="true"
                                              />
                                            </span>
                                          </div>
                                        </div>
                                        <div
                                          id="user_section"
                                          className="d-none"
                                        >
                                          <hr />
                                          <div className="form-group">
                                            <label>Allowed Users</label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="tab-pane" id="cpntnc">
                                    <div className="row mb-2">
                                      <div className="col-lg-12">
                                        <table className="table" id="tctable">
                                          <tbody>
                                            {couponDescription &&
                                              couponDescription?.map(
                                                (description, index) => (
                                                  <tr
                                                    className="row"
                                                    key={index}
                                                  >
                                                    <td className="col-lg-11">
                                                      <input
                                                        type="text"
                                                        id={`cpn_discription_${index}`}
                                                        className="form-control"
                                                        placeholder="Coupon Description"
                                                        name="cpn_discription"
                                                        value={description}
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            index,
                                                            e
                                                          )
                                                        }
                                                      />
                                                    </td>
                                                    <td className="col-lg-1">
                                                      <button
                                                        type="button"
                                                        className="btn btn-primary btn-icon btnDelete"
                                                        onClick={() =>
                                                          handleDeleteInput(
                                                            index
                                                          )
                                                        }
                                                      >
                                                        x
                                                      </button>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                          </tbody>
                                        </table>
                                      </div>
                                      <div className="col-lg-12">
                                        <button
                                          type="button"
                                          className="btn btn-primary add_new_tc"
                                          onClick={handleAddInput}
                                        >
                                          Add T&amp;C
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div className="tab-pane" id="cpntnc">
                            <div className="row mb-2">
                              <div className="col-lg-12">
                                <table className="table" id="tctable">
                                  <tbody>
                                    <tr className="row">
                                      <td className="col-lg-11">
                                        <input
                                          type="text"
                                          id="cpn_discription"
                                          className="form-control"
                                          placeholder="Coupon Discription"
                                          name="cpn_discription"
                                          value={couponDescription}
                                          onChange={(e) =>
                                            setcouponDescription(e.target.value)
                                          }
                                        />
                                      </td>
                                      <td className="col-lg-1">
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-icon btnDelete"
                                        >
                                          x
                                        </button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div className="col-lg-12">
                                <button
                                  type="button"
                                  className="btn btn-primary add_new_tc"
                                  onClick={duplicateInput}
                                >
                                  Add More T&amp;C
                                </button>
                              </div>
                            </div>
                          </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="card">
                          <div className="card-header">
                            <h4 className="card-title mb-0">Publish</h4>
                          </div>
                          <div className="card-body">
                            <div className="form-group">
                              <strong>Status</strong>
                              <select
                                className="form-control"
                                value={Status}
                                onChange={(e) => setStatus(e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                              </select>
                            </div>
                            {/* <div className="form-group">
                        <strong>Published on</strong>
                        <label className="form-control">07-Apr, 2024 10:49</label>
                      </div> */}
                          </div>
                          <div className="card-footer bg-secondary p-2">
                            <button
                              type="submit"
                              className="btn btn-primary btn-sm ml-auto"
                              name="generate_coupon"
                            >
                              Update Coupon
                            </button>
                          </div>
                          <input
                            type="hidden"
                            defaultValue="coupon_new"
                            id="action"
                            name="action"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal show d-block" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New User</h5>
                <button type="button" className="close" onClick={handleClose}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={AddUsers}>
                  <div className="form-group">
                    <label htmlFor="mobileNo">Mobile No.</label>
                    <input
                      type="tel"
                      className="form-control"
                      id="mobileNo"
                      placeholder="Enter mobile number"
                      value={mobile}
                      maxLength={10}
                      required
                      onChange={(e) => {
                        setMobile(e.target.value);
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter name"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </div>
                  <button type="submit" className="btn btn-success">
                    Submit
                  </button>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Editcoupons;
